module.exports = __webpack_public_path__ + "img/Received.c5812c2f.svg";